export const transactionsTranslation = {
  title: 'transactions.pageTitle',
  guarderia:{
    desc: 'transactions.guarderia.desc',
    kidName: 'transactions.guarderia.kidName',
    kidNamePlaceholder: 'transactions.guarderia.kidName.placeholder',
  },
  table: {
    title: 'transactions.table.title',
    noTransactions: 'transactions.table.noTransactions',
    noTransactionsGuarderia: 'transactions.table.noTransactionsGuarderia',
    noFilters: 'transactions.table.noFilters',
    filters: {
      beginDate: 'transactions.table.filters.beginDate',
      endDate: 'transactions.table.filters.endDate',
      product: {
        label: 'transactions.table.filters.product.label',
        placeholder: 'transactions.table.filters.product.placeholder',
        option: {
          ticketRestaurant: 'transactions.table.filters.service.option.ticketRestaurant',
          premium: 'transactions.table.filters.service.option.premium',
        },
      },
      service: {
        label: 'transactions.table.filters.service.label',
        placeholder: 'transactions.table.filters.service.placeholder',
        option: {
          onlinePurchase: 'transactions.table.filters.product.option.onlinePurchase',
          ticketRestaurant: 'transactions.table.filters.product.option.ticketRestaurant',
          iberiaCard: 'transactions.table.filters.product.option.iberiaCard',
          premium: 'transactions.table.filters.product.option.premium',
        },
      },
      errors: {
        dateWithin90days: 'transactions.table.filters.errors.dateWithin90days',
        endDateBeforeBeginDate:
          'transactions.table.filters.errors.endDateBeforeBeginDate',
      },
      local: {
        label: 'transactions.table.filters.local.label',
        placeholder: 'transactions.table.filters.local.placeholder',
        nurserySearchPlaceholder: 'transactions.table.filters.local.nurserySearchPlaceholder',
        search: 'transactions.table.filters.local.search',
        selectAll: 'transactions.table.filters.local.selectAll',
        selectAllNursery: 'transactions.table.filters.local.selectAllNursery',
        noOptionsTitle: 'transactions.table.filters.local.noOptionsTitle',
        noOptionsDescription: 'transactions.table.filters.local.noOptionsDescription',
      },
    },
    header: {
      affiliateCode: 'transactions.table.header.affiliateCode',
      transactionDate: 'transactions.table.header.transactionDate',
      liquidationDate: 'transactions.table.header.liquidationDate',
      local: 'transactions.table.header.local',
      transactionAmount: 'transactions.table.header.transactionAmount',
      invoiceNumber: 'transactions.table.header.invoiceNumber',
      invoiceNumberGuarderia: 'transactions.table.header.invoiceNumberGuarderia',
      product: 'transactions.table.header.product',
      service: 'transactions.table.header.service',
    },
  },
  buttons: {
    downloadTransactions: 'transactions.buttons.downloadTransactions',
  },
}
